import { render, staticRenderFns } from "./minha-jornada.vue?vue&type=template&id=04f98b12&scoped=true"
import script from "./minha-jornada.vue?vue&type=script&lang=js"
export * from "./minha-jornada.vue?vue&type=script&lang=js"
import style0 from "./minha-jornada.vue?vue&type=style&index=0&id=04f98b12&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04f98b12",
  null
  
)

export default component.exports